/* eslint-disable react-hooks/exhaustive-deps */
import apiGenericClient from "~services/utils/apiGenericClient";

const useRequisicoesOffline = () => {
  const save = async (ordered) => {
    switch (ordered.type) {
      case "mapaDaMina": {
        const client = new apiGenericClient("mapaMina", "/api/MapaMina");
        const response = await client.createData(ordered.toSend);

        return response.data === undefined ? response : response.data;
      }

      case "clienteFechadoConsomeBasicos": {
        const client = new apiGenericClient("mapaMina", "/api/MapaMina/FecharConsome");
        const response = await client.createData(ordered.toSend);

        return response.data === undefined ? response : response.data;
      }

      case "funilObra": {
        const client = new apiGenericClient("funilObra", "/api/FunilObra/Cliente");
        const response = await client.createData(ordered.toSend);

        return response.data === undefined ? response : response.data;
      }

      case "funilObraDataNegociacao": {
        const client = new apiGenericClient("funilObra", "/api/FunilObra/AtualizarDataNegociacao");
        const response = await client.createData(ordered.toSend);

        return response.data === undefined ? response : response.data;
      }

      case "funilObraNovoGrupo": {
        const client = new apiGenericClient("funilObra", "/api/FunilObra");
        const response = await client.createData(ordered.toSend);

        return response.data === undefined ? response : response.data;
      }
    }
  };

  return {
    save,
  };
};

export default useRequisicoesOffline;
